const baseClasses =
  "inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white text-sm font-semibold text-slate-700 shadow-sm transition-colors hover:border-slate-300 hover:text-slate-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-60";

export function outlineButtonClass({
  className = "",
}: {
  className?: string;
} = {}): string {
  return `${baseClasses} ${className}`.replace(/\s+/g, " ").trim();
}

